// One day in milliseconds is 1000 * 60 * 60 * 24
const msInDay = 864000000 as const;

export function daysBetween(date1: Date | string, date2 = new Date()): number {
    if (typeof date1 !== 'object') {
        date1 = new Date(date1);
    }

    return Math.ceil(
        (date1.getTime() - date2.getTime()) / msInDay
    );
}

export function daysBetweenFilter(): (date1: Date | string, date2?: Date) => number {
    return daysBetween;
}
